<div [classList]="canvas">
    <div id="mySidepanel" [classList]="open1">
        <div fxLayout="column wrap" fxFlex="100" class="editForm">
            <div class="headContent">
                <span class="head"> <b>{{ isLogs ? 'Access Logs' : 'New Report Request'}}</b></span>
                <i id="closeX" (click)="closeSidePanel(null)" class="flaticon-close"></i>
            </div>
            <div *ngIf="isLogs">
                You have accessed this report <span style="color: red;"> {{ logs.length }}
                </span> times
                <div class="setTable" style="margin-top: 10px;">
                    <ng-container *ngIf="logs?.length">
                        <mat-table [dataSource]="logs">
                            <ng-container [matColumnDef]="'downloaded_at'">
                                <mat-header-cell *matHeaderCellDef>Accessed On</mat-header-cell>
                                <mat-cell *matCellDef="let data" class="fs-12">
                                    <span>{{data.downloaded_at | date: 'dd MMM, yyyy h:mm a'}}</span>
                                </mat-cell>
                            </ng-container>

                            <ng-container [matColumnDef]="'status'">
                                <mat-header-cell *matHeaderCellDef>Download Status</mat-header-cell>
                                <mat-cell *matCellDef="let data" class="fs-12 ">
                                    <span [ngStyle]="{'color': data.status == 'success' ? 'green' : 'red'}">{{
                                        data.status
                                        != 'success' ? 'Error'
                                        : 'Success' }}</span>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row class="header-row" *matHeaderRowDef="logColumns"></mat-header-row>
                            <mat-row *matRowDef="let row; columns: logColumns;"></mat-row>
                        </mat-table>
                    </ng-container>
                </div>
            </div>
            <logzy-new-report-request-form [bindReport]="reportSubject" *ngIf="!isLogs"
                (closeNewRequestSidePanel)="closeSidePanel($event)"></logzy-new-report-request-form>
        </div>
    </div>
</div>
<logzy-reports-table [downloadButtons]="false" [refreshTable]="refreshReportTable"
    (openNewReportSidePanel)="openEdit($event)" (openLogsSidePanel)="showLogs($event)"></logzy-reports-table>